'use client';

import Head from 'next/head';
import { useEffect } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import gsap from 'gsap';
import { useLenis } from '../hooks/LenisProvider';

import About from '../components/About';
import Main from '../components/Main';
import Navbar from '../components/Navbar';
import WerWirSind from '../components/WerWirSind';
import ServiceSelection from '../components/Service';
import Katalog from '../components/Katalog';
import Vision from '../components/Vision';
import Kontakt from '../components/Kontakt';
import Footer from '../components/Footer';

export default function Home() {
  const lenis = useLenis();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('gsap/ScrollTrigger').then((m) => {
        gsap.registerPlugin(m.default);
      });
    }
  }, []);

  useEffect(() => {
    if (!lenis) return;
    return () => {
      if (typeof window !== 'undefined') {
        import('gsap/ScrollTrigger').then((m) => {
          m.default.getAll().forEach((t) => t.kill());
        });
      }
    };
  }, [lenis]);

  useEffect(() => {
    if (!lenis) return;
    const scrollToHash = () => {
      if (typeof window === 'undefined') return;
      const id = window.location.hash.replace('#', '');
      const el = id ? document.getElementById(id) : null;
      if (el) {
        lenis.scrollTo(el, { offset: -64, duration: 0.1, easing: (t) => t });
      }
    };
    scrollToHash();
    window.addEventListener('hashchange', scrollToHash);
    return () => window.removeEventListener('hashchange', scrollToHash);
  }, [lenis]);

  return (
    <>
      <Head>
        <title>reefli — nachhaltige Flaschen & Designs</title>
        <meta
          name="description"
          content="Nachhaltige Flaschen, individuelles Design und hochwertige Veredelung. Erfahre mehr über REEFLI™."
        />
      </Head>

      <main className="w-screen overflow-x-hidden">
        <Navbar />
        <div className="bg-reefliBeige font-[futura]">
        <Main />
        <About id="about" />
        <WerWirSind />
        <ServiceSelection id="service" />
        <Katalog id="products" />
        <Vision id="design" />
        {/* <div className="bg-reefliBeige font-[futura]"> */}
          <Kontakt id="contact" />
          <Footer />
        </div>
      </main>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'main',
        'about',
        'navbar',
        'werwirsind',
        'service',
        'vision',
        'katalog',
        'footer',
        'kontakt',
        'business',
        'request',
      ])),
    },
  };
}
